const FontSize = []
for(let i = 6; i <= 20; i++) {
	FontSize.push({ value: `${i}`, label: `${i}` })
}

export default FontSize
